import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTask = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 3C3.89688 3 3 3.89688 3 5V15C3 16.1031 3.89688 17 5 17H12V13.5C12 12.6719 12.6719 12 13.5 12H17V5C17 3.89688 16.1031 3 15 3H5ZM17 13H15.5844H13.5C13.225 13 13 13.225 13 13.5V15.5844V17L14 16L16 14L17 13Z",
		fill: "#0D2976"
	})
});
export default SvgTask;
